import React, { Component } from 'react';
import { FormDataConsumer, BooleanInput, SelectInput, SimpleForm, DateInput, ReferenceArrayInput, AutocompleteArrayInput,
    SelectArrayInput, Button } from 'react-admin';
import { AlertComponent } from '../components/alerts.js';
import RunReportIcon from '@material-ui/icons/PlayCircleFilledRounded';
import authProvider from '../authProvider';
import { SummaryComponent, AuctionOptimizerComponent, RevenueEfficiencyComponent, RevenuePerformanceDeviation, AuctionOptimizerDevices,
    TotalAuctionOptimizerComponent, MarketMoversAnalysisComponent, AdstxtAnalysisComponent, BidderAnomaliesComponent,
    SummarySectionComponent, RealtimeSummaryComponent }
    from './components';
const utils = require('../components/utils');

const DEFAULT_DATE_RANGE = 30;
const BASE_URL = window.nobid_endpoint + '/pubreports_report?show=revenue&show=profit&show=tech_cost&show=pub_rpm_bid_requests&show=ad_requests&';
const isAuthorized = (role) => ['admin', 'report_admin', 'bidder', 'advertiser'].includes(role);
const FormToolbar = props => (<span></span>);
const SHOW_ROW = [1, 2, 3, 4, 5, 6];

function linearRegression(y) {
    const total = y.length
    let i = 1
    let x = []
    let sumx = 0
    let sumy = 0
    let sumxy = 0
    let sumxx = 0
    y.map(v => {
      x.push(i)
      sumy += v
      sumx += i
      sumxy += i * v
      sumxx += i * i
      i++
    })
  
    let num = total * sumxy - sumx * sumy
    let den = total * sumxx - sumx * sumx
  
    let slope = num / den
    let intercept = (sumy - slope * sumx) / total;
  
    return { slope: slope, intercept: intercept };
  }

const dateRangeChoices = [
    { id: '0', name: 'Today' },
    { id: 1, name: 'Yesterday' },
    { id: 2, name: 'Last 2 Days' },
    { id: 3, name: 'Last 3 Days' },
    { id: 5, name: 'Last 5 Days' },
    { id: 7, name: 'Last 7 Days' },
    { id: 8, name: 'Last 8 Days' },
    { id: 10, name: 'Last 10 Days' },
    { id: 15, name: 'Last 15 Days' },
    { id: 30, name: 'Last 30 Days' },
    { id: 'lm', name: 'Last Month' },
    { id: 'mtd', name: 'Month to Date' },
    { id: 'mty', name: 'Month to Yesterday' },
    { id: 'ytd', name: 'Year to Date' },
    { id: 'yty', name: 'Year to Yesterday' },
    { id: 'custom', name: 'Custom' }
  ];
  
  const choicesInterval = [
    { id: 'day', name: 'Daily' },
    { id: 'week', name: 'Weekly' },
    { id: 'month', name: 'Monthly' },
    { id: 'year', name: 'Yearly' }
  ];
  
  const choicesDevices = [
    { id: 'Computer', name: 'Desktop' },
    { id: 'Mobile', name: 'Mobile' },
    { id: 'Tablet', name: 'Tablet' }
  ];
  
  const choicesAdType = [
    { id: 'banner', name: 'BANNER' },
    { id: 'native', name: 'NATIVE' },
    { id: 'video', name: 'VIDEO' }
  ];
  const choicesChannel = [
    { id: 'web', name: 'WEB' },
    { id: 'app', name: 'APP' }
  ];

export default class DashboardChart extends Component {
    imps = [];
    adreqs = [];
    revs = [];
    grev = [];
    prof = [];
    cost = [];
    cpms = [];
    profit = [];
    pubBrRpm = [];
    totalRev = 0;
    totalGrossRev = 0;
    totalImp = 0;
    lrimps = [];
    lradreqs = [];
    lrrevs = [];
    lrgrevs = [];
    lrcpms = [];
    minAdRequests;
    maxAdRequests;
    slopeAdRequests;
    interceptAdRequests;
  
    roundVal = (v, decimals) => {
      return utils.roundDouble(v ,decimals);
    }
  
    state = {
      loading: true,
      role: null,
      params: ['_end=1000000', '_order=ASC', '_sort=id', '_start=0', `date_range=${DEFAULT_DATE_RANGE}`],
      baseUrl: BASE_URL,
      totalAccepted: 0,
      totalOptimized: 0,
      devicesData: {},
      panelRevenuePerformance: {},
      submit: true
    }

    constructor(props) {
      super(props);
    }

    updateState(results) {
      this.imps = [];
      this.adreqs = [];
      this.revs = [];
      this.grev = [];
      this.prof = [];
      this.cost = [];
      this.cpms = [];
      this.pubBrRpm = [];
      this.profit = [];
      this.totalRev = 0;
      this.totalGrossRev = 0;
      this.totalImp = 0;
      this.totalAdreq = 0;
      this.lrimps = [];
      this.lradreqs = [];
      this.lrrevs = [];
      this.lrgrevs = [];
      this.lrcpms = [];
      if (results && results.length > 0) for (let i in results) {
        let d = '' + results[i].date;
        d = d.substring(0, d.indexOf('T'));
        let rev = this.roundVal(results[i].net_revenue);
        let revg = this.roundVal(isAuthorized(this.state.role) ? results[i].revenue : results[i].net_revenue);
        let profit = this.roundVal(results[i].profit);
        let s = { x: (new Date(d)).getTime(), y: rev }
        this.totalRev += rev;
        this.totalGrossRev += revg;
        this.lrrevs.push(rev);
        this.lrgrevs.push(revg);
        this.revs.push(s);
  
        let imp = results[i].impressions;
        s = { x: (new Date(d)).getTime(), y: imp }
        this.totalImp += imp;
        this.lrimps.push(imp);
        this.imps.push(s);

        let adreq = results[i].ad_requests;
        s = { x: (new Date(d)).getTime(), y: adreq }
        this.totalAdreq += adreq;
        this.lradreqs.push(adreq);
        this.adreqs.push(s);
  
        s = { x: (new Date(d)).getTime(), y: this.roundVal(results[i].avg_cpm || 0.0, 3) }
        this.lrcpms.push(results[i].avg_cpm);
        this.cpms.push(s);
  
        s = { x: (new Date(d)).getTime(), y: this.roundVal(isAuthorized(this.state.role) ? results[i].revenue : results[i].net_revenue) }
        this.grev.push(s);
  
        s = { x: (new Date(d)).getTime(), y: this.roundVal(results[i].profit || 0.0) }
        this.prof.push(s)
  
        s = { x: (new Date(d)).getTime(), y: this.roundVal(results[i].tech_cost || 0.0) }
        this.cost.push(s)
  
        s = { x: (new Date(d)).getTime(), y: this.roundVal(results[i].pub_rpm_bid_requests || 0.0) }
        this.pubBrRpm.push(s);
  
        s = { x: (new Date(d)).getTime(), y: this.roundVal(results[i].profit || 0.0) }
        this.profit.push(s);
      }
      this.setState({ loading: false, submit: false });
      this.minAdRequests = Math.min(...this.lradreqs);
      this.maxAdRequests = Math.max(...this.lradreqs);
      this.slopeAdRequests = linearRegression(this.lradreqs).slope;
      this.interceptAdRequests= linearRegression(this.lradreqs).intercept;
    }

    fetchData() {
      this.setState({ loading: true });
      let url = `${this.state.baseUrl}${this.state.params.join('&')}`;
      let options = { headers: new Headers() };
      options.headers.set('accept', 'application/json');
      const token = localStorage.getItem('token');
      options.headers.set('Authorization', `Bearer ${token}`);
      fetch(url, options).then((response) => {
        return response.json();
      })
        .then((results) => {
          this.updateState(results);
        });
    }

    async componentDidMount() {
      const { role } = await authProvider.getPermissions();
      this.setState({ role }, () => {
        this.fetchData();
      });
    }
  
    setOptimizerData = ({totalAccepted, totalOptimized, devicesData}) => {
      this.setState({ totalAccepted: totalAccepted, totalOptimized: totalOptimized, devicesData: devicesData });
    }
  
    setPubBrRpmData = (panelRevenuePerformance) => {
      this.setState({ panelRevenuePerformance: panelRevenuePerformance });
    }
  
    handlePublisherInputChanged = (value) => {
      return this.handleFilterChanged(value, 'publisher_id');
    }

    handleAdTypeInputChanged = (value) => {
      return this.handleFilterChanged(value.target.value, 'ad_type');
    }

    handleChannelInputChanged = (value) => {
      return this.handleFilterChanged(value.target.value, 'channel');
    }

    handleSiteInputChanged = (value) => {
      return this.handleFilterChanged(value, 'site_id');
    }

    handleBidderInputChanged = (value) => {
      return this.handleFilterChanged(value, 'bidder_id');
    }

    handleCountryInputChanged = (value) => {
      return this.handleFilterChanged(value.target.value, 'country');
    }

    handleDeviceInputChanged = (value) => {
      return this.handleFilterChanged(value.target.value, 'device');
    }

    handleFilterChanged = (values, thekey) => {
      const key = thekey + '='
      this.state.params = this.state.params.filter(word => !word.startsWith(key));
      values.forEach(element => {
        this.state.params.push(key + element);
      })
    }

    handleInputChanged = (value) => {
      this.state.params = this.state.params.filter(word => !word.startsWith(value.target.name + '='));
      this.state.params.push(`${value.target.name}=${value.target.value}`);
    }

    handleDateRangeChanged = (value) => {
      this.state.params = this.state.params.filter(word => !word.startsWith(value.target.name + '='));
      this.state.params.push(`${value.target.name}=${value.target.value}`);
      this.state.dateRange = value.target.value;
  
      this.setState({ dateRange: value.target.value });
    }

    handleRunReport = () => {
      this.setState({ submit: true })
      this.fetchData();
    }
  
    render() {
      const { loading, dateRange, params, role } = this.state;
      if (!role) return null;
      return (
  
        <div>
          <AlertComponent />
  
          <SimpleForm toolbar={<FormToolbar />}>
  
            <Encapsulator>
                <div style={{ width: '100%', overflow: 'hidden' }}>
    
                <div style={{ float: 'left', overflow: 'hidden', display: 'flex', columnGap: '1em' }} id="wrapper2">
                    <SelectInput label="Interval" source="interval" choices={choicesInterval} defaultValue='day' 
                    disabled={loading} onChange={this.handleInputChanged}/>
                    <div>
                    <SelectInput label="Date Range" source="date_range"
                        onChange={this.handleDateRangeChanged}
                        choices={dateRangeChoices}
                        defaultValue={`${DEFAULT_DATE_RANGE}`}
                        disabled={loading} />
                    <div style={{ float: 'right', paddingLeft: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                        <div style={{ float: 'left', paddingRight: '5px', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                        <DateInput label="Start Date" source="start_date" allowEmpty disabled={loading}
                            style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} 
                            onChange={this.handleInputChanged} />
                        </div>
                        <div style={{ float: 'left', display: ('custom' !== dateRange) ? 'none' : 'block' }}>
                        <DateInput label="End Date" source="end_date" allowEmpty disabled={loading}
                            style={{ display: ('custom' !== dateRange) ? 'none' : 'block' }} 
                            onChange={this.handleInputChanged} />
                        </div>
                    </div>
                    </div>
                    
                    <div>
                    <Button label="Refresh Dashboard" onClick={this.handleRunReport} props={this.props} variant="contained"
                    style={{marginTop: '18px', padding: '7px', width: '190px'}} color="primary" startIcon={<RunReportIcon />} disabled={loading}/>
                    </div>
                    
                </div>
    
                {role!=='advertiser' &&
                <div style={{ float: 'right', paddingRight: '5px', marginTop: '10px' }}>
                    <BooleanInput source='showFilters' label="Show Filters"></BooleanInput>
                </div>
                }
                </div>
            
    
                <FormDataConsumer>
                {({ formData, ...rest }) => formData.showFilters &&
    
                    <div style={{ width: '100%', overflow: 'hidden' }}>
    
                    <div style={{ float: 'left', paddingRight: '5px' }}>
                        <SelectArrayInput label="Devices"
                        source="device"
                        choices={choicesDevices}
                        onChange={this.handleDeviceInputChanged}
                        style={{ width: '200px' }}
                        disabled={loading} />
                    </div>
    
                    {isAuthorized(role) && role!=='bidder' &&
                        <div style={{ float: 'left', paddingRight: '5px' }}>
                        <ReferenceArrayInput
                            source="bidder_id"
                            label="Bidder"
                            reference="bidders"
                            basePath="bidders"
                            sort={{ field: 'name', order: 'ASC' }}
                            filterToQuery={searchText => ({ search_name: searchText })}
                            allowEmpty
                            onChange={this.handleBidderInputChanged}
                            disabled={loading} >
                            <AutocompleteArrayInput disabled={loading} label="Bidder" optionText="name" optionValue="code" />
                        </ReferenceArrayInput>
                        </div>
                    }
    
                    <div style={{ float: 'left', paddingRight: '5px' }}>
                        <SelectArrayInput label="Ad Type"
                        source="ad_type"
                        choices={choicesAdType}
                        onChange={this.handleAdTypeInputChanged}
                        style={{ width: '150px' }}
                        disabled={loading} />
                    </div>
    
                    <div style={{ float: 'left', paddingRight: '5px' }}>
                        <SelectArrayInput label="Channel" 
                        source="channel" 
                        choices={choicesChannel} 
                        onChange={this.handleChannelInputChanged} 
                        style={{ width: '150px' }}
                        disabled={loading} />
                    </div>
    
                    {role!=='bidder' &&
                    <div style={{ float: 'left', paddingRight: '5px' }}>
                        <ReferenceArrayInput
                        source="publisher_id"
                        label="Publisher"
                        reference="publishers"
                        basePath="publishers"
                        perPage={15}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => ({ search_name: searchText })}
                        allowEmpty
                        onChange={this.handlePublisherInputChanged}
                        disabled={loading}>
                        <AutocompleteArrayInput disabled={loading} label="Publishers" optionText="name" optionValue="code" />
                        </ReferenceArrayInput>
                    </div>
                    }

                    {role!=='bidder' &&
                    <div style={{ float: 'left', paddingRight: '5px' }}>
                        <ReferenceArrayInput
                        source="site_id"
                        label="Site"
                        reference="sites"
                        basePath="sites"
                        perPage={20}
                        sort={{ field: 'name', order: 'ASC' }}
                        filterToQuery={searchText => utils.siteFormFilter(searchText, formData)}
                        allowEmpty
                        onChange={this.handleSiteInputChanged}
                        disabled={loading}>
                        <AutocompleteArrayInput disabled={loading} label="Sites" optionValue="code"
                        optionText={ x => utils.formatSiteName(x) } />
                        </ReferenceArrayInput>
                    </div>
                    }
                    {role!=='bidder' && <span style={{ fontSize: '12px' }}>Start typing your site name</span>}
    
                    </div>
    
                }
                </FormDataConsumer>
                {role!=='advertiser' &&
                  <RealtimeSummaryComponent authProvider={authProvider} params={params} submit={this.state.submit} />
                }
                {SHOW_ROW.includes(1) &&
                <SummaryComponent
                    totalRevenue= {isAuthorized(role) ? this.totalGrossRev : this.totalRev}
                    totalImpressions= {this.totalImp}
                    totalAdRequests= {this.totalAdreq}
                    averageCPM= {isAuthorized(role) ? this.roundVal(1000 * this.totalGrossRev / this.totalImp) : this.roundVal(1000 * this.totalRev / this.totalImp)}
                    slopeRevenue= {isAuthorized(role) ? linearRegression(this.lrgrevs).slope : linearRegression(this.lrrevs).slope}
                    slopeImpressions= {linearRegression(this.lrimps).slope}
                    slopeAdRequests= {this.slopeAdRequests}
                    slopeCPM= {linearRegression(this.lrcpms).slope}
                    interceptRevenue= {isAuthorized(role) ? linearRegression(this.lrgrevs).intercept : linearRegression(this.lrrevs).intercept}
                    interceptImpressions= {linearRegression(this.lrimps).intercept}
                    interceptAdRequests= {this.interceptAdRequests}
                    interceptCPM= {linearRegression(this.lrcpms).intercept}
                    minRevenue= {isAuthorized(role) ? Math.min(...this.lrgrevs) : Math.min(...this.lrrevs)}
                    maxRevenue= {isAuthorized(role) ? Math.max(...this.lrgrevs) : Math.max(...this.lrrevs)}
                    minImpressions= {Math.min(...this.lrimps)}
                    maxImpressions= {Math.max(...this.lrimps)}
                    minAdRequests= {this.minAdRequests}
                    maxAdRequests= {this.maxAdRequests}
                    minCPM= {Math.min(...this.lrcpms)}
                    maxCPM= {Math.max(...this.lrcpms)}
                    imps={this.imps}
                    adreqs={this.adreqs}
                    revs={this.grev}
                    cpms={this.cpms}
                    loading={this.state.loading}
                />
                }
                {SHOW_ROW.includes(2) && role!=='bidder' && (role!=='advertiser' && isAuthorized(role) || role === 'publisher') && <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '5px', width: '100%', overflow: 'hidden', paddingTop: '4px', align: 'center' }} >
                        <div style={{width: '50%'}}>
                            <AuctionOptimizerComponent authProvider={authProvider} setOptimizerData={this.setOptimizerData} revs={this.grev} params={this.state.params} submit={this.state.submit} />
                        </div>
                        <div style={{width: '20%'}}>
                            <TotalAuctionOptimizerComponent authProvider={authProvider} totalAccepted={this.state.totalAccepted} totalOptimized={this.state.totalOptimized} loading={this.state.loading}/>
                        </div>
                        <div style={{width: '30%'}}>
                            <AuctionOptimizerDevices devicesData={this.state.devicesData} loading={this.state.loading} />
                        </div>
                    </div>
                  </>}
                  {SHOW_ROW.includes(3) && (role === 'admin') && <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', gap: '5px', width: '100%', overflow: 'hidden', paddingTop: '4px', align: 'center' }} >
                        <div style={{width: '50%'}}>
                            <RevenueEfficiencyComponent authProvider={authProvider} setPubBrRpmData={this.setPubBrRpmData}  pubBrRpm={this.pubBrRpm} profit={this.profit} params={params} loading={this.state.loading}/>
                        </div>
                        <div style={{width: '50%'}}>
                          <SummarySectionComponent
                            title='Ad REQUESTS'
                            tooltip='ad requests'
                            color='yellow'
                            value={(this.totalAdreq) ? new Intl.NumberFormat('en-US').format(this.totalAdreq) : "-"}
                            min={(this.minAdRequests) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(this.minAdRequests) : "-"}
                            max={(this.maxAdRequests) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(this.maxAdRequests) : "-"}
                            slope={(this.slopeAdRequests) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(this.slopeAdRequests) : "-"}
                            intercept={(this.interceptAdRequests) ? new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(this.interceptAdRequests) : "-"}
                            graphValues={this.adreqs}
                            loading={loading}
                          />
                        </div>
                        {/* <div style={{width: '50%'}}>
                            <RevenuePerformanceDeviation authProvider={authProvider} panelRevenuePerformance={this.state.panelRevenuePerformance} pubRevPerformance={this.pubBrRpm} loading={this.state.loading}/>
                        </div> */}
                    </div>
                </>}
                { SHOW_ROW.includes(4) && role!=='bidder' && role!=='advertiser' &&
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '5px', width: '100%', overflow: 'hidden', paddingTop: '10px', align: 'center' }} >
                    <div style={{width: '49.7%'}}>
                      <MarketMoversAnalysisComponent authProvider={authProvider} params={this.state.params} parentLoading={this.state.loading}/>
                    </div>
                    <div style={{width: '50%'}}>
                      <AdstxtAnalysisComponent authProvider={authProvider} params={this.state.params} parentLoading={this.state.loading}/>
                    </div>
                </div>
                } 
                { SHOW_ROW.includes(5) && (role === 'admin') &&
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '5px', width: '100%', overflow: 'hidden', paddingTop: '10px', align: 'center' }} >
                  <div style={{width: '49.7%'}}>
                    <BidderAnomaliesComponent authProvider={authProvider} params={this.state.params} parentLoading={this.state.loading}/>
                  </div>
                </div>
                }
            </Encapsulator>
  
          </SimpleForm>
        </div>
      );
    }
  }

const Encapsulator = React.memo(function NonInput({ children }) {
    return children;
  });